import React from 'react'
import { InputNumber } from 'antd'
import { observer } from 'mobx-react-lite'
import type { FieldMethods } from '../types'

export interface NumberInputProps {
    field?: FieldMethods
    index?: number
    disabled?: boolean
    className?: string
    style?: React.CSSProperties
    [key: string]: any
}

export const NumberInput: React.FC<NumberInputProps> = observer(({ field, index }) => {
    if (!field) {
        return null
    }

    return (
        <InputNumber
            {...field.bind({ index: index ?? 0 })}
            parser={(value) => (value ?? '').replace(',', '.')}
        />
    )
})
